import {EPlayerSidebarStatType} from "@nitra/nkmb-card-components";
import {useTranslation} from "react-i18next";
import {ScoreAssistTableCell} from "views/competitions/playerStatSidebar/ScoreAssistTableCell";
import {ScoreAssistTableRow} from "views/competitions/playerStatSidebar/ScoreAssistTableRow";

export function ScoreAssistHeaderRow(props: {
	type: EPlayerSidebarStatType,
}) {
	const {type} = props;
	const {t} = useTranslation();

	return (
		<ScoreAssistTableRow nonDefaultBackground={true}>
			<ScoreAssistTableCell text={"#"} bold={true}/>
			<ScoreAssistTableCell text={t("generic.nameSurname")} bold={true} wide={true}/>
			<ScoreAssistTableCell text={t("competition.scoreAssistHeaderRow.matches")} bold={true}/>
			<ScoreAssistTableCell text={t("competition.scoreAssistHeaderRow.minutes")} bold={true}/>
			<ScoreAssistTableCell
				text={type === EPlayerSidebarStatType.GOAL ? t("competition.scoreAssistHeaderRow.goals") : t("competition.scoreAssistHeaderRow.assists")}
				bold={true}/>
		</ScoreAssistTableRow>
	)
}
